<template>
    <div class="card card-article" v-if="posts.length > 0">
        <div class="card-header bg-light">
            <div class="card-header-title">
                Review
            </div>
        </div>
        <reviews :posts="posts"></reviews>
    </div>
</template>

<script>
    import axios from 'axios';
    import Reviews from './Reviews';
    export default {
        name: 'SectionReviews',
        components: {
            Reviews,
        },
        data() {
            return {
                posts: [],
                errors: []
            }
        },
        props: [
            'sectionId',
        ],
        created() {
            let baseUri = process.env.MOVEEK_API_ENDPOINT;
            axios.get(baseUri + '/v1/posts?section.id=' + this.sectionId + '&category.id=895&page=1&page_size=5&status=publish&publish_at[strictly_before]=' + encodeURIComponent(this.$root.moment().toISOString(true)))
                .then(response => {
                    this.posts = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                });
        }
    }
</script>

<style scoped>
</style>
